<template>
    <div id="vue-results">
        <div class="listing" v-for="result in searchResults" :key="result.key">
            <div class="listing__content">
                <div class="listing__title"><a :target="result.openInNewWindow ? '_blank' : ''" :href="result.url" :aria-label="getAriaText(result)">{{result.title}}</a>
                </div>
                <div class="listing__meta"><span class="listing__meta-item listing__file"><span v-if="result.iconClass"
                            :class="result.iconClass"></span>{{result.contentTypeLabel}}</span>
                            <span v-if="result.metadata1 != result.contentTypeLabel" class="listing__meta-item listing__metadata">{{result.metadata1}}</span>
                            <span v-if="result.metadata2" class="listing__meta-item listing__metadata">{{result.metadata2}}</span>
                            <span v-if="result.metadata3" class="listing__meta-item listing__metadata">{{result.metadata3}}</span>
                </div>
                <div class="listing__description">
                    <p>{{result.summary}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            searchResults: function () {
                return this.$store.state.results.itemResults;
            },
            settings: function () {
                return this.$store.state.settings;
            },

        },
        methods: {
            getAriaText: function (item) {
                if (item != null) {
                    return "Click to go to " + item.title;
                } else {
                    return "";
                }
            }
        }
    }
</script>

<style>

</style>